import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

/**
 * A single row in the metadata section of an object view.
 * @param {string} label The label of the row, like "Title" or "Creator".
 * @param {any} children The value associated with the label, like a string or a date.
 * @param {boolean} [idRow=false] If true, the label is expected to be an ID, and the
 * value will be displayed in a narrow column.
 * @returns {React.JSX.Element} A JSX element representing the row.
 * @throws {Error} If label or children are not specified.
 * @throws {Error} If idRow is specified and its value is not a boolean.
 */
export const MetadataRow = ({label, children, idRow = false}) => {

    if (!label) {
        throw Error('label is required');
    }

    if (!children) {
        throw Error('children is required');
    }

    if (idRow && typeof (idRow) !== 'boolean') {
        throw Error('idRow must be a boolean value, when specified');
    }

    return <Box sx={{marginBottom: '8px'}}>
        <Typography variant="caption" color={"secondary"}
                    sx={{minWidth: idRow ? '24px' : '110px', display: 'inline-block'}}>{label}:</Typography>
        <Typography variant="caption">{children}</Typography>
    </Box>;
};
